import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ConnectionSignal"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.3 16.1849C4.2226 14.6268 3 12.1816 3 9.58486C3 6.98812 4.2226 4.54291 6.3 2.98486L7.2 4.18486C5.50031 5.45963 4.5 7.46025 4.5 9.58486C4.5 11.7095 5.50031 13.7101 7.2 14.9849L6.3 16.1849ZM17.6999 16.1849L16.7999 14.9849C18.4996 13.7101 19.4999 11.7095 19.4999 9.58486C19.4999 7.46025 18.4996 5.45963 16.7999 4.18486L17.6999 2.98486C19.7773 4.54291 20.9999 6.98812 20.9999 9.58486C20.9999 12.1816 19.7773 14.6268 17.6999 16.1849ZM12.7503 8.99991H11.2503V22.4999H12.7503V8.99991ZM8.49771 13.6649C7.38291 12.6689 6.74561 11.2448 6.74561 9.7499C6.74561 8.25496 7.38291 6.83092 8.49771 5.8349L9.50271 6.9524C8.7057 7.66388 8.25001 8.68153 8.25001 9.7499C8.25001 10.8183 8.7057 11.8359 9.50271 12.5474L8.49771 13.6649ZM14.4978 12.5474L15.5028 13.6649C16.6176 12.6689 17.2549 11.2448 17.2549 9.7499C17.2549 8.25496 16.6176 6.83092 15.5028 5.8349L14.4978 6.9524C15.2948 7.66388 15.7505 8.68153 15.7505 9.7499C15.7505 10.8183 15.2948 11.8359 14.4978 12.5474Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ConnectionSignal.vue"]]);
